import type React from "react";

interface BankTransferInfo {
	reference: string;
	amount: string;
	email: string;
}

interface ThankYouSectionProps {
	isVisible: boolean;
	bankTransferInfo?: BankTransferInfo | null;
}

export const ThankYouSection: React.FC<ThankYouSectionProps> = ({
	isVisible,
	bankTransferInfo,
}) => {
	if (!isVisible) return null;

	return (
		<section id="thankyou-section">
			<h2>Thank you!</h2>

			{bankTransferInfo ? (
				<div className="bank-transfer-notice">
					<p>
						We've sent bank transfer instructions to{" "}
						<strong>{bankTransferInfo.email}</strong>.
					</p>
					<p className="check-spam">
						Please check your inbox (and spam folder) for the email with details
						on how to complete your transfer.
					</p>
					<div className="reference-box">
						<p className="reference-label">Your donation reference:</p>
						<p className="reference-number">{bankTransferInfo.reference}</p>
						<p className="reference-amount">
							Amount: {bankTransferInfo.amount}
						</p>
					</div>
				</div>
			) : (
				<p>Your receipt will be sent to your email address.</p>
			)}

			<div className="tax-info">
				<p>
					GiveWise is a project of Effective Altruism Hong Kong Limited
					("EAHK"). EAHK is a tax-exempt charity under section 88 of the Inland
					Revenue Ordinance (Cap. 112) (File No. 91/19582). Your donation of
					$100 and more may be tax-deductible for tax paid in Hong Kong. If you
					have not received a donation receipt within 5 business days of your
					donation and would like to request one, please e-mail{" "}
					<a href="mailto:info@givewise.org.hk">info@givewise.org.hk</a> with
					your e-mail, name, donation amount, and date of donation.
				</p>
			</div>

			<h3>Any questions?</h3>

			<p>
				Please email us at{" "}
				<strong>
					<a href="mailto:info@givewise.org.hk">info@givewise.org.hk</a>
				</strong>{" "}
				if you have any questions.
			</p>

			<p>Best wishes and thanks,</p>
			<p>
				<strong>The GiveWise Team</strong>
			</p>
		</section>
	);
};
